import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { colors, spacing, Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { useDashMessages } from 'intl/intl.hooks'

interface Props {
  mobileUrl?: string
  desktopUrl?: string
  logoUrl?: string
  backgroundUrl?: string
}

const sectionContainer = css({
  display: 'flex',
  flexDirection: 'column',
})

const rowContainer = css({
  display: 'flex',
  marginBottom: spacing.X24,
  width: '100%',
})

const imageLargeContainer = css({
  width: '300px',
})

const imageSmallContainer = css({
  width: '150px',
})

const placeholderImageStyle = css({
  border: `1px dashed ${colors.GRAYSCALE.X30}`,
  marginTop: spacing.X8,
  marginLeft: spacing.X8,
  marginRight: spacing.X8,
})

const imageStyle = css({
  width: '100%',
  display: 'block',
})

export const BannerDetailsContentImage: FunctionComponent<Props> = ({
  mobileUrl,
  desktopUrl,
  logoUrl,
  backgroundUrl,
}) => {
  const messages = useDashMessages({
    mobileImageLabel: 'bannersDomain.details.image.mobile',
    desktopImageLabel: 'bannersDomain.details.image.desktop',
    logoImageLabel: 'bannersDomain.details.image.logo',
    backgroundImageLabel: 'bannersDomain.details.image.background',
    emptyValue: 'bannersDomain.field.empty.value',
  })

  return (
    <MerchandisingFormSection titleId="bannersDomain.details.image.title">
      <div css={sectionContainer}>
        {mobileUrl && (
          <div css={rowContainer} key="banner-details-info-image-mobile">
            <div css={[imageSmallContainer]}>
              <Text weight="semibold">{messages.mobileImageLabel}</Text>
              <div css={placeholderImageStyle}>
                <img css={imageStyle} src={mobileUrl} />
              </div>
            </div>
          </div>
        )}
        {desktopUrl && (
          <div css={rowContainer} key="banner-details-info-image-desktop">
            <div css={[imageLargeContainer]}>
              <Text weight="semibold">{messages.desktopImageLabel}</Text>
              <div css={placeholderImageStyle}>
                <img css={imageStyle} src={desktopUrl} />
              </div>
            </div>
          </div>
        )}
        {logoUrl && (
          <div css={rowContainer} key="banner-details-info-image-logo">
            <div css={[imageSmallContainer]}>
              <Text weight="semibold">{messages.logoImageLabel}</Text>
              <div css={placeholderImageStyle}>
                <img css={imageStyle} src={logoUrl} />
              </div>
            </div>
          </div>
        )}
        {backgroundUrl && (
          <div css={rowContainer} key="banner-details-info-image-background">
            <div css={[imageLargeContainer]}>
              <Text weight="semibold">{messages.backgroundImageLabel}</Text>
              <div css={placeholderImageStyle}>
                <img css={imageStyle} src={backgroundUrl} />
              </div>
            </div>
          </div>
        )}
      </div>
    </MerchandisingFormSection>
  )
}
